var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _path0, _g3, _path1, _path10, _g4, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 39,
    viewBox: "0 0 84 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91119 29.1659H3.55123V31.3637H7.40035V32.9081H3.55123V35.9375H1.62667V27.6215H7.91119V29.1659ZM12.9088 36.0801C10.5446 36.0801 9.14281 34.7257 9.14281 32.2785V27.6215H11.0674V32.2072C11.0674 33.7872 11.7564 34.4406 12.9206 34.4406C14.0968 34.4406 14.7739 33.7872 14.7739 32.2072V27.6215H16.6747V32.2785C16.6747 34.7257 15.2729 36.0801 12.9088 36.0801ZM24.3027 27.6215H26.2035V35.9375H24.6235L20.4773 30.8885V35.9375H18.5765V27.6215H20.1685L24.3027 32.6705V27.6215ZM28.171 35.9375V27.6215H31.9489C34.6694 27.6215 36.5346 29.2609 36.5346 31.7795C36.5346 34.2981 34.6694 35.9375 31.9489 35.9375H28.171ZM30.0956 34.3575H31.8538C33.5052 34.3575 34.5862 33.3714 34.5862 31.7795C34.5862 30.1876 33.5052 29.2015 31.8538 29.2015H30.0956V34.3575ZM40.7184 36.0801C39.3997 36.0801 38.0691 35.688 37.3326 35.1178L37.986 33.6684C38.6869 34.1793 39.7323 34.5357 40.7302 34.5357C41.8707 34.5357 42.334 34.1555 42.334 33.6447C42.334 32.0884 37.4989 33.1576 37.4989 30.0688C37.4989 28.6551 38.6394 27.4789 41.0035 27.4789C42.0489 27.4789 43.1181 27.7284 43.8903 28.2155L43.2963 29.6767C42.5241 29.2372 41.7282 29.0233 40.9916 29.0233C39.8511 29.0233 39.4116 29.451 39.4116 29.9737C39.4116 31.5063 44.2467 30.4489 44.2467 33.5021C44.2467 34.8921 43.0944 36.0801 40.7184 36.0801ZM56.2894 27.6215H58.1308L55.4103 35.9375H53.3432L51.5137 30.3064L49.6247 35.9375H47.5695L44.8371 27.6215H46.8329L48.71 33.4665L50.6702 27.6215H52.4522L54.353 33.514L56.2894 27.6215ZM65.14 35.9375L64.4035 34.1555H60.5425L59.8059 35.9375H57.8338L61.5404 27.6215H63.4412L67.1596 35.9375H65.14ZM61.1602 32.6943H63.7976L62.4789 29.5104L61.1602 32.6943ZM68.0224 35.9375V27.6215H69.947V34.3693H74.1168V35.9375H68.0224ZM81.475 35.9375L80.7385 34.1555H76.8775L76.1409 35.9375H74.1688L77.8754 27.6215H79.7762L83.4946 35.9375H81.475ZM77.4952 32.6943H80.1326L78.8139 29.5104L77.4952 32.6943Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6213 18.5304L52.6276 18.5156L52.6094 18.518L52.6213 18.5304Z",
    fill: "#004B84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4756 15.3562C41.2537 20.3045 46.2546 25.3653 51.74 20.2763L47.5282 16.0578C46.8661 15.4777 46.2265 14.8552 45.6342 14.2648C44.8826 13.5156 44.0515 12.6103 43.1681 11.6908V11.6901C41.0451 9.47907 38.6226 7.18469 36.2742 6.77307C31.5464 5.9462 22.9901 16.3508 20.0547 21.586C26.8879 16.4337 30.6156 9.28679 36.4756 15.3562Z",
    fill: "#DC241B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3581 9.76522C50.7513 3.96481 42.4349 -5.78042 37.1328 5.45201H37.134C41.4091 -2.13183 55.3138 28.5316 64.6262 18.4989L56.3581 9.76522Z",
    fill: "#E45C16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5375 13.9078C38.0779 6.1468 43.8332 21.4568 51.1778 20.2757L47.1435 16.2347C46.4893 15.6619 45.8637 15.0532 45.2444 14.438C44.4091 13.6044 43.6075 12.7274 42.7882 11.8732L42.7749 11.8599C41.0316 10.0439 38.4395 7.43204 35.9958 7.00447C34.4228 6.72947 32.5397 7.81286 31.2808 8.69693C30.3295 9.37562 29.4265 10.1194 28.5781 10.923C27.6461 11.7925 26.7567 12.7167 25.9029 13.6712C24.6943 15.023 23.5445 16.4481 22.4692 17.9222C21.8144 18.8201 21.1687 19.7539 20.5781 20.7141C21.4197 20.0353 22.2332 19.3181 23.0351 18.5857C24.0228 17.6849 24.9912 16.7581 25.9932 15.8759C26.7508 15.2093 27.611 14.4845 28.5375 13.9078Z",
    fill: "url(#paint0_linear_899_4435)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_899_4435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 6,
    width: 32,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5453 13.9C38.0857 6.13898 43.841 21.449 51.1856 20.2679L47.1513 16.2269C46.4971 15.6541 45.8715 15.0454 45.2522 14.4302C44.4169 13.5965 43.6153 12.7196 42.796 11.8654L42.7827 11.8521C41.0394 10.0361 38.4473 7.42422 36.0037 6.99665C34.4307 6.72165 32.5476 7.80505 31.2886 8.68912C30.3374 9.36781 29.4343 10.1116 28.5859 10.9152C27.6539 11.7847 26.7645 12.7088 25.9107 13.6634C24.7021 15.0152 23.5523 16.4403 22.4771 17.9144C21.8222 18.8123 21.1765 19.7461 20.5859 20.7063C21.4275 20.0275 22.241 19.3103 23.0429 18.5779C24.0306 17.6771 24.999 16.7502 26.001 15.868C26.7586 15.2014 27.6188 14.4767 28.5453 13.9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_899_4435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1855 6.14062H20.5859V21.4506H51.1855V6.14062Z",
    fill: "url(#paint1_linear_899_4435)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1438 15.7288C38.6123 17.2429 40.1449 18.7978 41.8188 20.0506C43.2268 21.1039 44.864 22.0284 46.6083 22.1553C48.4598 22.2904 50.0482 21.4964 51.4294 20.2685C44.085 21.4495 38.3295 6.13952 28.7891 13.9006C29.72 13.3211 30.7169 12.8911 31.7439 12.8185C33.6662 12.6826 35.301 13.821 36.6296 15.1965L37.1438 15.7288Z",
    fill: "url(#paint2_linear_899_4435)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_899_4435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 11,
    width: 24,
    height: 12
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1516 15.7288C38.6201 17.2429 40.1527 18.7978 41.8266 20.0506C43.2346 21.1039 44.8718 22.0284 46.6161 22.1553C48.4676 22.2904 50.056 21.4964 51.4372 20.2685C44.0928 21.4495 38.3373 6.13952 28.7969 13.9006C29.7278 13.3211 30.7247 12.8911 31.7517 12.8185C33.6741 12.6826 35.3088 13.821 36.6375 15.1965L37.1516 15.7288Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_899_4435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4372 6.14844H28.7969V22.2994H51.4372V6.14844Z",
    fill: "url(#paint3_linear_899_4435)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3428 4.08872C44.8365 -0.258155 55.8225 18.7013 64.317 18.4998L56.2037 9.92785C54.8333 8.51105 53.4913 7.06785 52.0762 5.7011C50.6413 4.31444 49.0691 2.92547 47.3833 1.90137C45.9957 1.05877 44.3705 0.378415 42.7495 0.539345C40.6138 0.751535 39.0988 2.37459 38.0156 4.21962C38.1202 4.16551 38.2297 4.12153 38.3427 4.08828",
    fill: "url(#paint4_linear_899_4435)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_899_4435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 0,
    width: 27,
    height: 19
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3506 4.09653C44.8443 -0.250343 55.8303 18.7092 64.3248 18.5076L56.2115 9.93566C54.8411 8.51886 53.4991 7.07566 52.084 5.70891C50.6491 4.32225 49.0769 2.93328 47.3911 1.90918C46.0035 1.06658 44.3784 0.386227 42.7573 0.547157C40.6216 0.759347 39.1066 2.3824 38.0234 4.22743C38.128 4.17333 38.2375 4.12935 38.3505 4.09609",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_899_4435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3247 -0.242188H38.0234V18.7173H64.3247V-0.242188Z",
    fill: "url(#paint5_linear_899_4435)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3871 13.255C50.3042 14.2108 51.2407 15.1504 52.2149 16.0412C53.1167 16.8784 54.0737 17.654 55.0794 18.363C56.6882 19.4751 58.6587 20.4766 60.6218 20.288C61.9807 20.1576 63.1152 19.4806 64.0758 18.4964C55.5809 18.6979 44.5948 -0.261553 38.1016 4.08532C38.8849 3.85432 39.7186 4.16529 40.4116 4.55568C41.3658 5.09281 42.2833 5.89383 43.0892 6.65327C44.1348 7.63711 45.1294 8.69432 46.1108 9.74889C47.2012 10.9195 48.2807 12.101 49.3871 13.2547",
    fill: "url(#paint6_linear_899_4435)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_899_4435",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 3,
    width: 27,
    height: 18
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3793 13.2472C50.2964 14.203 51.2329 15.1426 52.2071 16.0334C53.1089 16.8706 54.0659 17.6462 55.0716 18.3552C56.6803 19.4673 58.6509 20.4688 60.6139 20.2802C61.9729 20.1498 63.1074 19.4728 64.0679 18.4886C55.5731 18.6901 44.5869 -0.269366 38.0938 4.0775C38.8771 3.8465 39.7108 4.15747 40.4038 4.54786C41.358 5.08499 42.2755 5.88601 43.0814 6.64545C44.127 7.62929 45.1215 8.6865 46.103 9.74107C47.1934 10.9117 48.2729 12.0932 49.3793 13.2469",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_899_4435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0679 -0.257812H38.0938V20.4799H64.0679V-0.257812Z",
    fill: "url(#paint7_linear_899_4435)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9922 12.458C36.1195 9.97554 40.1511 14.0008 44.0882 17.1504C40.1595 13.9296 36.1468 9.67106 30.9922 12.458Z",
    fill: "#F1FAFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0312 3.46875C44.7478 3.90402 49.3466 8.71861 53.9834 12.7823C49.3179 8.55284 44.6941 3.52859 41.0312 3.46875Z",
    fill: "#F1FAFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_4435",
    x1: 45.2415,
    y1: 16.3956,
    x2: 32.5412,
    y2: 6.97657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_899_4435",
    x1: 45.2186,
    y1: 18.0978,
    x2: 33.1974,
    y2: -4.07644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_899_4435",
    x1: 32.7058,
    y1: 12.9314,
    x2: 37.6814,
    y2: 25.5767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_899_4435",
    x1: 35.6569,
    y1: 11.7851,
    x2: 47.1291,
    y2: 24.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_899_4435",
    x1: 38.0156,
    y1: 9.50852,
    x2: 64.317,
    y2: 9.50852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_899_4435",
    x1: 49.7012,
    y1: 15.6079,
    x2: 51.1273,
    y2: 3.69943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_899_4435",
    x1: 38.1016,
    y1: 11.8742,
    x2: 64.0758,
    y2: 11.8742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_899_4435",
    x1: 46.1977,
    y1: 5.34138,
    x2: 55.9588,
    y2: 20.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC221A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78809"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bd813c3dc8ce9e8142941b39715ab871.svg";
export { ForwardRef as ReactComponent };